import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Layout pathless `_public` — agrupa rutas no autenticadas (marketing landing,
 * /login, /signup, /productos, /api, /precios, etc).
 *
 * Decisión: NO renderiza ningún wrapper aquí. Cada child route elige su propio
 * chrome (AuthShell para login/signup, PublicShell para marketing en Slice G).
 * Esto evita acoplar dos layouts visualmente distintos al mismo padre.
 *
 * Si el user ya está autenticado, redirigimos a /dashboard antes de renderizar
 * cualquiera de las páginas hijas (un usuario logueado no debería ver landing
 * ni el form de login).
 */
export const Route = createFileRoute('/_public')({
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: PublicLayout,
});

function PublicLayout(): JSX.Element {
  return <Outlet />;
}
